"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _react = _interopRequireDefault(require("react"));

function Icon(_ref) {
  var size = _ref.size,
      color = _ref.color;
  color = color || "#c84f3e"; //console.log(color)

  return /*#__PURE__*/_react.default.createElement("svg", (0, _defineProperty2.default)({
    style: {
      width: size,
      height: size
    },
    xmlns: "http://www.w3.org/2000/svg",
    width: "300mm",
    height: "300mm",
    viewBox: "0 0 300mm 300mm",
    version: "1.1"
  }, "viewBox", "0 0 300 300"), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", {
    fillOpacity: "1",
    strokeWidth: "0.764",
    transform: "matrix(1.30846 0 0 1.3085 23.632 .645)"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "96.571",
    cy: "114.148",
    r: "89.001",
    fill: color,
    stroke: "none",
    strokeLinecap: "square",
    strokeWidth: "7.642"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    stroke: "none",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeMiterlimit: "4",
    strokeOpacity: "1",
    strokeWidth: "1.758",
    d: "M95.555 48.23c-5.04.1-10.038 1.784-14.148 4.478-8.35 5.44-13.429 15.141-14.095 24.985-.175 4.222-.01 8.45-.076 12.673.035 3.978-.096 7.968.222 11.936 1.062 9.44 6.198 18.566 14.321 23.667 4.378 2.805 9.62 4.32 14.755 4.257a27.106 27.106 0 005.093-.533 27.465 27.465 0 006.052-2c8.761-4.06 14.93-12.685 16.898-22.032 1.165-5.242.657-10.61.767-15.946-.013-4.392.112-8.793-.175-13.178-.938-9.787-6.43-19.387-15.021-24.476-3.483-2.094-7.62-3.424-11.542-3.743a31.686 31.686 0 00-3.05-.088zm.733 7.183c7.294-.06 14.215 4.283 17.937 10.456 3.062 4.866 4.187 10.737 3.928 16.429-.046 6.244.116 12.494-.118 18.734-.652 7.7-4.814 15.258-11.57 19.214-6.068 3.634-14.107 3.723-20.193.075-6.203-3.57-10.313-10.193-11.441-17.192-.123-.636-.244-1.272-.365-1.908 4.037-.066 8.084.117 12.114-.11 2.384-.476 3.605-3.7 2.044-5.6-.895-1.239-2.517-1.669-3.976-1.488H74.433V85.04c8.209-.025 16.422.062 24.627-.065 2.435-.328 3.895-3.53 2.386-5.53-.83-1.249-2.395-1.796-3.843-1.598H74.448c.624-6.311 3.237-12.581 7.98-16.898 3.74-3.458 8.746-5.546 13.86-5.536zm-40.354 49.392c-2.179.047-3.75 2.363-3.369 4.43.161 9.415 4.415 18.58 11.101 25.1 5.88 5.836 13.305 9.8 21.322 11.729 2.659.65 5.285 1.038 7.983 1.29-.076 9.885-.236 19.772-.217 29.655.268 2.367 3.254 3.876 5.295 2.595 1.412-.788 2.038-2.5 1.85-4.053l.266-28.201c5.696-.445 11.31-1.831 16.568-4.222 8.476-3.828 15.886-10.398 20.096-18.789 2.404-4.756 3.795-10.17 3.786-15.55.176-1.634-.832-3.284-2.41-3.788-1.874-.722-4.136.486-4.607 2.432-.278 1.38-.091 2.814-.335 4.206-.96 8.24-5.702 15.788-12.298 20.723-11.47 8.709-27.648 10.195-40.8 4.606-7.535-3.19-14.122-8.93-17.64-16.39-1.763-3.7-2.752-7.777-2.786-11.881.096-1.416-.73-2.952-2.088-3.562a3.296 3.296 0 00-1.717-.33z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    strokeLinecap: "square",
    strokeWidth: "7.642",
    d: "M95.103-.482c-22.657.238-45.182 7.43-63.771 20.388-19.8 13.728-35.168 33.792-43.052 56.579-8.038 23.04-8.46 48.671-1.114 71.948 6.614 21.17 19.565 40.294 36.736 54.33 15.295 12.58 33.89 21.151 53.439 24.404 22.146 3.755 45.401.916 65.904-8.304 22.725-10.138 41.98-27.866 53.902-49.714 9.76-17.763 14.66-38.152 14.012-58.412-.565-19.484-6.175-38.81-16.258-55.503-12.257-20.413-30.976-36.9-52.854-46.328A114.522 114.522 0 0095.103-.482zm1.471 13.872c16.646-.011 33.335 4.14 47.975 12.115 15.51 8.389 28.742 20.92 37.946 35.96 6.507 10.595 11.058 22.476 13.236 34.733 2.521 14.118 2.063 28.718-1.447 42.633-3.531 14.119-10.237 27.493-19.447 38.828-8.038 9.867-18.013 18.305-29.128 24.496a100.27 100.27 0 01-41.545 12.465c-16.138 1.213-32.589-1.451-47.487-7.91-17.043-7.325-31.914-19.42-42.574-34.623-9.928-14.068-16.13-30.73-17.79-47.87-1.859-18.747 1.518-37.935 9.95-54.842A101.37 101.37 0 0132.44 36.394c9.921-8.178 21.47-14.481 33.76-18.358a101.885 101.885 0 0130.375-4.646z",
    color: "#000"
  }))));
}

var _default = Icon;
exports.default = _default;